import { GDPR_COOKIE_KEY_PREFIX } from 'rlink-cookies/constants';

export default function getGdprCookieKey (appName, gdprCookieVersion) {
  return `${GDPR_COOKIE_KEY_PREFIX}-${appName}-${gdprCookieVersion}`;
}


// WEBPACK FOOTER //
// ./lib/rlink-cookies/getGDPRCookieKey.js